import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Lux Sensor Icon Style 03 - Brightness High (Material Symbol)
 */
export const Style03_Brightness: React.FC<DeviceIconProps> = ({
  isOn = true,
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-amber-400' : 'text-slate-400';

  return (
    <span
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      brightness_high
    </span>
  );
};

export default Style03_Brightness;
